const state = () => ({
    metricsInformation: {},
    hasViewGraphic: false,
});

const getters = {
    getMetrics(state) {
        return state;
    },
};

const actions = {};

const mutations = {
    setMetrics(state, payload) {
        state.metricsInformation = payload.metricsInformation;
        state.hasViewGraphic = payload.hasViewGraphic;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
